import { all, takeLatest, put, select } from 'redux-saga/effects';
import { PRESCORING_URL, PRESCORING_AUTH } from 'containers/App/constants';
import {
  SET_CONTRACTUAL_CATEGORY,
  SET_CONTRACTUAL_CATEGORY_OFFER,
  CHECK_SUSTAINABILITY_REQUEST,
  CHECK_SUSTAINABILITY_OFFER_REQUEST,
  UPDATE_PROPOSAL,
  SAVE_QUOTATION,
} from './constants'
import {
  toggleLoading,
  receiveLogic,
  receiveOfferLogic,
  receiveSustainabilityResponse,
  receiveSustainabilityOfferResponse,
  closeModal,
  parsePrescoringParamsToFilters,
} from './actions';
import {
  saveQuotationSuccess,
  saveQuotationError,
  setUpdated
} from '../Quotation/actions';

import { makeSelectSelectedParams, makeSelectParam } from '../Search/selectors';

import { makeSelectCheckInputData, makeSelectOfferCheckInputData, makeSelectIsLoading } from './selectors';
import { makeSelectUser } from 'containers/App/selectors';
import { getRequestHeadersAsLogged, getRefreshToken, responseHandler } from '../../utils/auth';

function* fetchLogic({contractualCategory}) {
  const isLoading = yield select(makeSelectIsLoading());
  const user = yield select(makeSelectUser());
  const requestURL = `${PRESCORING_URL}logic/${contractualCategory}`;

  if (!isLoading) {
    yield put(toggleLoading(true));

    try {
      const parameters = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${PRESCORING_AUTH}`,
          'X-Refresh-Tkn': getRefreshToken(),
          'X-Agent-Id': `${user.code}`,
          'X-Agent-Email': `${user.email}`,
        },
      };

      const response = yield fetch(requestURL, parameters).then(response =>
        responseHandler(response)
      );

      yield put(toggleLoading(false));

      yield put(receiveLogic(response));
    } catch (err) {
      console.log('request error', err);
      alert('Spiacenti, si è verificato un errore con la richiesta. Si prega di riprovare');
      yield put(receiveLogic({}));
    }
  }
}

function* fetchLogicOffer({contractualCategory}) {
  const isLoading = yield select(makeSelectIsLoading());
  const user = yield select(makeSelectUser());
  const requestURL = `${PRESCORING_URL}logic/${contractualCategory}`;

  if (!isLoading) {
    yield put(toggleLoading(true));

    try {
      const parameters = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${PRESCORING_AUTH}`,
          'X-Refresh-Tkn': getRefreshToken(),
          'X-Agent-Id': `${user.code}`,
          'X-Agent-Email': `${user.email}`,
        },
      };

      const response = yield fetch(requestURL, parameters).then(response =>
        responseHandler(response)
      );

      yield put(toggleLoading(false));

      yield put(receiveOfferLogic(response));
    } catch (err) {
      console.log('request error', err);
      alert('Spiacenti, si è verificato un errore con la richiesta. Si prega di riprovare');
      yield put(receiveOfferLogic({}));
    }
  }
}

function* requestCheck() {
  const isLoading = yield select(makeSelectIsLoading());
  const inputData = yield select(makeSelectCheckInputData());
  const user = yield select(makeSelectUser());
  const requestURL = `${PRESCORING_URL}check`;

  if (!isLoading) {
    yield put(toggleLoading(true));

    try {
      const encodedInputData = inputData.hasOwnProperty('_root') ? inputData.toJS() : inputData;
      const parameters = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${PRESCORING_AUTH}`,
          'X-Refresh-Tkn': getRefreshToken(),
          'X-Agent-Id': `${user.code}`,
          'X-Agent-Email': `${user.email}`,
        },
        body: JSON.stringify(encodedInputData)
      };

      const response = yield fetch(requestURL, parameters).then(response =>
        responseHandler(response)
      );

      if (response.success) {
        yield put(receiveSustainabilityResponse(response.data));

        if (!location.pathname.startsWith('/quotations/')) {
          if (!(new RegExp('^\/offers\/[a-z0-9]+', 'i')).test(location.pathname)) {
            const currentSelectedParams = yield select(makeSelectSelectedParams());
            const currentParams = yield select(makeSelectParam());

            yield parsePrescoringParamsToFilters(response.data, currentSelectedParams, currentParams, inputData.contractualCategory);
          }
        }

        yield put(toggleLoading(false));
      } else {
        console.log('request error', response.error, response.errorCode);
        alert('Spiacenti, si è verificato un errore 1 con la richiesta. Si prega di riprovare');
        yield put(receiveSustainabilityResponse({}));
        yield put(closeModal());
      }
    } catch (err) {
    //   console.log('request error', err);
    //   alert('Spiacenti, si è verificato un errore 2 con la richiesta. Si prega di riprovare');
    //   yield put(receiveSustainabilityResponse({}));
    //   yield put(closeModal());
    }
  }
}

function* requestOfferCheck({offer}) {
  const isLoading = yield select(makeSelectIsLoading());
  const inputData = yield select(makeSelectOfferCheckInputData());
  const user = yield select(makeSelectUser());
  const requestURL = `${PRESCORING_URL}offer-check`;

  if (!isLoading) {
    yield put(toggleLoading(true));

    try {
      const encodedInputData = inputData && inputData.hasOwnProperty('_root') ? inputData.toJS() : inputData || {};
      encodedInputData.offerData = offer;

      const parameters = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${PRESCORING_AUTH}`,
          'X-Refresh-Tkn': getRefreshToken(),
          'X-Agent-Id': `${user.code}`,
          'X-Agent-Email': `${user.email}`,
        },
        body: JSON.stringify(encodedInputData)
      };

      const response = yield fetch(requestURL, parameters).then(response =>
        responseHandler(response)
      );

      if (response.success) {
        yield put(toggleLoading(false));
        yield put(receiveSustainabilityOfferResponse(response.data));
      } else {
        console.log('request error', response.error, response.errorCode);
        alert('Spiacenti, si è verificato un errore 1 con la richiesta. Si prega di riprovare');
        yield put(receiveSustainabilityOfferResponse({}));
      }
    } catch (err) {
      console.log('request error', err);
      alert('Spiacenti, si è verificato un errore 2 con la richiesta. Si prega di riprovare');
      yield put(receiveSustainabilityOfferResponse({}));
    }
  }
}

function* updateProposal({proposal}) {
  const isLoading = yield select(makeSelectIsLoading());

  if (!isLoading) {
    yield put(toggleLoading(true));
    const requestURL = `${process.env.API_URL}proposals/${proposal.id}`;
    const user = yield select(makeSelectUser());

    proposal.contractual_category = proposal.customer.category.id;
    proposal.fiscal_code = proposal.customer.fiscal_code;

    try {
      const parameters = {
        method: 'PUT',
        headers: {
          ...getRequestHeadersAsLogged(),
          'X-Agent-Id': `${user.code}`,
          'X-Agent-Email': `${user.email}`,
        },
        body: JSON.stringify(proposal),
      };

      const response = yield fetch(requestURL, parameters).then(response =>
        responseHandler(response)
      );

      if (response.data && response.data.id && response.data.sustainability) {
        // window.location.replace('/quotations/' + response.data.id);
      } else {
        alert('Spiacenti, si è verificato un errore con la richiesta. Si prega di riprovare');
        console.error('request error', response);
      }
      yield put(toggleLoading(false));
    } catch (err) {
      console.log('request error', err);
    }
  }
}

function* saveQuotation({quotation}) {
  const isLoading = yield select(makeSelectIsLoading());

  if (!isLoading) {
    yield put(toggleLoading(true));
    const requestURL = `${process.env.API_URL}quote`;

    try {
      const parameters = {
        method: 'POST',
        headers: getRequestHeadersAsLogged(),
        body: JSON.stringify(quotation),
      };

      const response = yield fetch(requestURL, parameters).then(response =>
        responseHandler(response)
      );

      if (response.data && response.data.quotation && response.data.quotation.data.code) {
        yield put(saveQuotationSuccess(response.data));
        window.location.reload();
        // attenzione: non fare reset prescoring da qui, vengono cancellati alcuni dati nella proposal del db
      } else {
        yield put(saveQuotationError(response.errors));
      }
      yield put(toggleLoading(false));
    } catch (err) {
      console.log('request error', err);
    }
  }
}

function* actionWatcher() {
  yield takeLatest(SET_CONTRACTUAL_CATEGORY, fetchLogic);
  yield takeLatest(SET_CONTRACTUAL_CATEGORY_OFFER, fetchLogicOffer);
  yield takeLatest(CHECK_SUSTAINABILITY_REQUEST, requestCheck);
  yield takeLatest(CHECK_SUSTAINABILITY_OFFER_REQUEST, requestOfferCheck);
  yield takeLatest(UPDATE_PROPOSAL, updateProposal);
  yield takeLatest(SAVE_QUOTATION, saveQuotation);
}

export default function* optionData() {
  yield all([actionWatcher()]);
}
